"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = exports.GRID_COLUMNS = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var react_1 = __importDefault(require("react"));
var responsive_1 = require("../../utils/responsive");
var GridItem_1 = require("./GridItem");
exports.GRID_COLUMNS = 12;
var GRID_GUTTERS_DEFAULT = 16;
var GRID_GUTTERS_SMALL = 24;
var GRID_GUTTERS_MEDIUM = 32;
var GRID_GUTTERS_LARGE = 40;
var StyledGrid = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n\n  ", "\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n\n  ", "\n"])), function (_a) {
    var disableRowSpacing = _a.disableRowSpacing;
    return (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin: ", ";\n    width: calc(100% + ", "px);\n\n    ", "\n\n    ", "\n\n   ", "\n\n    > ", " {\n      ", ";\n\n      ", ";\n\n      ", ";\n\n      ", ";\n    }\n  "], ["\n    margin: ", ";\n    width: calc(100% + ", "px);\n\n    ", "\n\n    ", "\n\n   ", "\n\n    > ", " {\n      ", ";\n\n      ", ";\n\n      ", ";\n\n      ", ";\n    }\n  "])), disableRowSpacing
        ? "0 -".concat(GRID_GUTTERS_DEFAULT / 2, "px")
        : "-".concat(GRID_GUTTERS_DEFAULT / 2, "px"), GRID_GUTTERS_DEFAULT, (0, responsive_1.small)((0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin: ", ";\n      width: calc(100% + ", "px);\n    "], ["\n      margin: ", ";\n      width: calc(100% + ", "px);\n    "])), disableRowSpacing
        ? "0 -".concat(GRID_GUTTERS_SMALL / 2, "px")
        : "-".concat(GRID_GUTTERS_SMALL / 2, "px"), GRID_GUTTERS_SMALL)), (0, responsive_1.medium)((0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      margin: ", ";\n      width: calc(100% + ", "px);\n    "], ["\n      margin: ", ";\n      width: calc(100% + ", "px);\n    "])), disableRowSpacing
        ? "0 -".concat(GRID_GUTTERS_MEDIUM / 2, "px")
        : "-".concat(GRID_GUTTERS_MEDIUM / 2, "px"), GRID_GUTTERS_MEDIUM)), (0, responsive_1.large)((0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      margin: ", ";\n      width: calc(100% + ", "px);\n    "], ["\n      margin: ", ";\n      width: calc(100% + ", "px);\n    "])), disableRowSpacing
        ? "0 -".concat(GRID_GUTTERS_LARGE / 2, "px")
        : "-".concat(GRID_GUTTERS_LARGE / 2, "px"), GRID_GUTTERS_LARGE)), GridItem_1.StyledGridItem, (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        padding: ", ";\n      "], ["\n        padding: ", ";\n      "])), disableRowSpacing
        ? "0 ".concat(GRID_GUTTERS_DEFAULT / 2, "px")
        : "".concat(GRID_GUTTERS_DEFAULT / 2, "px")), (0, responsive_1.small)((0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        padding: ", ";\n      "], ["\n        padding: ", ";\n      "])), disableRowSpacing
        ? "0 ".concat(GRID_GUTTERS_SMALL / 2, "px")
        : "".concat(GRID_GUTTERS_SMALL / 2, "px"))), (0, responsive_1.medium)((0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        padding: ", ";\n      "], ["\n        padding: ", ";\n      "])), disableRowSpacing
        ? "0 ".concat(GRID_GUTTERS_MEDIUM / 2, "px")
        : "".concat(GRID_GUTTERS_MEDIUM / 2, "px"))), (0, responsive_1.large)((0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        padding: ", ";\n      "], ["\n        padding: ", ";\n      "])), disableRowSpacing
        ? "0 ".concat(GRID_GUTTERS_LARGE / 2, "px")
        : "".concat(GRID_GUTTERS_LARGE / 2, "px"))));
});
/**
 * The basis for our 12-point grid system. Should always be used in conjunction with `GridItem`.
 */
var Grid = function (_a) {
    var children = _a.children, disableRowSpacing = _a.disableRowSpacing, className = _a.className;
    return (react_1.default.createElement(StyledGrid, { disableRowSpacing: disableRowSpacing, className: className }, children));
};
exports.Grid = Grid;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
